module.exports = __webpack_public_path__ + "media/kr.6d3d963f.svg";